import Selectors from './utils/selectors.js';

const selectors = new Selectors();

export default class AutoTabFields {
    constructor(options = {}) {
        this.id = options.id;
        this.thresholdAttr = options.thresholdAttr || 'maxlength';
        this.inputContainer = document.querySelector(this.id);
        this.setupTabListener();
    }

    setupTabListener() {
        let inputFields = selectors.querySelectorArray('input', this.inputContainer),
            self = this;
        inputFields.forEach(function(el, index) {
            let maxlength = el.getAttribute(self.thresholdAttr);
            if (maxlength.length && index != inputFields.length - 1) {
                el.addEventListener('keyup', (e) => {
                    if (e.key.length == 1 && el.value.length == maxlength) {
                        inputFields[index + 1].focus();
                    }
                });
            }
        });
    }
}
